import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { AccountService } from '../../service/app/account.service';
import swal from 'sweetalert2';

export interface LoginModel {
  data: any
}

@Component({
  selector: 'app-login-modal',
  templateUrl: './login.modal.html'
})
export class LoginModalComponent extends DialogComponent<LoginModel, string> implements LoginModel, OnInit {


  data: any;

  showMessage = false;
  showConfirm = false;
  @Output()
  onSuccess = new EventEmitter<any>();
  form: FormGroup;
  formRecover: FormGroup;
  formRecoverSet: FormGroup;

  errorRecover = '';
  errorRecoverSet = '';

  constructor(dialogService: DialogService, private accountService: AccountService) {
    super(dialogService);
  }

  viewUi = 'login'

  get(value: string){
    return this.form.get(value);
  }



  ngOnInit() {

    this.form = new FormGroup({})
    this.template();

    this.formRecover = new FormGroup({
      'email': new FormControl('', [Validators.required, Validators.email])
    })

    this.formRecoverSet = new FormGroup({
      'code': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required]),
      'passwordRepeat': new FormControl('', [Validators.required]),
    })
  }

  confirm() {
    this.result = this.form.get('email').value;
    this.close();
  }


  template() {
    this.form.addControl('email', new FormControl('', [Validators.required, Validators.email]));
    this.form.addControl('password', new FormControl('', Validators.required));
    /* this.form.addControl('email', new FormControl('comercio1@gmail.com', [Validators.required, Validators.email]));
    this.form.addControl('password', new FormControl('123', Validators.required)); */
  }

  changeView(value) {
    this.viewUi = value;
  }

  send() {
    if (this.form.valid) {
      this.showMessage = false;
      this.accountService.login(this.form.value)
        .then(result => {
          if (result == undefined) {
            this.confirm();
            this.clear();
            this.onSuccess.emit();
          } 
          else {
            if(result.error == "user_dont_validate")
            {
              this.showConfirm = true;
              this.showMessage = false;
            }
            else
            {
              this.showConfirm = false;
              this.showMessage = true;  
            }
            
            //this.confirm();
          }
        })
    }
  }

  recover() {
    this.accountService.sendCode(this.formRecover.get('email').value)
      .then(result => {
        if (result) {
          //this.viewUi = 'recoverSet'
          swal({
            type: 'success',
            title: 'Proceso completo',
            text: 'Favor revisar su correo, se envio las instrucciones para recuperar su contraseña.'
          })


        } else {
          //this.errorRecover = 'El correo no se registro.'
          swal({
            type: 'error',
            title: 'Disculpe las molestias',
            text: 'El correo indicado no se ha registrado, Favor de Validar.',
          })
        }
      })
  }

  resend(){
    swal({
      title: '¿Desea continuar?',
      text: "Se enviara de nuevo un correo con las instrucciones para confirmar su cuenta!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.value) {
        this.accountService.reenviarCorreo(this.form.controls.email.value)
        .then(result =>
        {
          if(result == "email_not_exist")
          {
            swal({
              type: 'error',
              title: 'Disculpe las molestias',
              text: 'El correo indicado no se ha registrado aun, favor de proceder con el registro.',
            });
          }

          if(result == "error")
          {
            swal({
              type: 'error',
              title: 'Disculpe las molestias',
              text: 'Los servicios no estan activos en este momento, favor de intentarlo en otro momento',
            })
          }

          if(result == "ok")
          {
            swal({
              type: 'success',
              title: 'El correo fue reenviado',
            })
          }
        })
      }
    })    
  }

  recoverSet() {
    let result = {
      ...this.formRecoverSet.value,
      email: this.formRecover.get('email').value
    }
    this.accountService.recover(result)
      .then(result => {
        if (result) {
          this.viewUi = 'login'
        } else {
          this.errorRecoverSet = 'Codigo invalido o las contraseñas no son iguales.'
        }
      })
  }

  clear(){
    this.form.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/modal/login.modal.ts